(function(){
'use strict';
var T=(window.MDS_T)||{cart:{},p:{},a:{},g:{},c:{}};
var EN_JS={
 'cart.empty':'Your bag is empty.','cart.see_collection':'See the collection','cart.remove':'Remove',
 'cart.subtotal':'Subtotal','cart.shipping':'Insured shipping','cart.complimentary':'Complimentary',
 'cart.total':'Total','cart.checkout':'Checkout','cart.methods':'MB WAY · Multibanco · Card · Apple Pay',
 'product.add':'Add to bag','product.sold_out':'Sold out','product.unavailable':'Unavailable',
 'product.adding':'Adding…','product.variant_sold_out':'This variant is sold out. Write to us and we will make it to order.',
 'appointment.title':'Private appointment','appointment.sub':'Rua de Damão 109, Alcabideche · measurements take twenty minutes',
 'appointment.subject':'Subject','appointment.what':'What you have in mind — occasion, piece, timing',
 'appointment.note':'For bespoke and made-to-order above €1,500 the visit is required: feet cannot be measured remotely.',
 'appointment.cta':'Request appointment','general.name':'First name','general.phone':'Phone','general.email':'Email',
 'configurator.choose_size':'Choose a size.'};
function tr(key,fallback){ if(T._lang==='en'&&EN_JS[key])return EN_JS[key]; return fallback||''; }
var LOC=(T.locale||'pt').indexOf('en')===0?'en-GB':'pt-PT';
var LEATHERS=[{k:'cognac',n:'Cognac',c:'#8A5A32',s:'#6F4526',add:0},
 {k:'ebano',n:'Ébano',c:'#2C2521',s:'#1C1714',add:0},
 {k:'areia',n:'Areia',c:'#C2A77E',s:'#A78C64',add:60},
 {k:'oceano',n:'Oceano',c:'#2E3C4E',s:'#1F2A38',add:120}];
var MATS=[{k:'vitela',n:'Vitela',add:0},{k:'camurca',n:'Camurça',add:140},{k:'cordovan',n:'Cordovan',add:420},{k:'marinho',n:'Fibra marinha',add:220}];
var SOLES=[{k:'couro',n:'Couro',add:0},{k:'borracha',n:'Borracha natural',add:90}];
var DETAILS=[{k:'no',n:'Nó de pescador',add:0},{k:'franja',n:'Franja',add:80},{k:'liso',n:'Liso',add:0},{k:'mono',n:'Monograma gravado',add:160}];
var SIZES=['35','36','37','38','39','40','41','42','43','44','45'];
var S={leather:'cognac',mat:'vitela',sole:'couro',detail:'no',size:null,base:0};
var THREE_VIEW=null;

function money(n){try{return new Intl.NumberFormat(LOC,{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(n)}catch(e){return n+' €'}}
function cents(c){return money(Math.round(c)/100)}
function find(a,k){for(var i=0;i<a.length;i++){if(a[i].k===k)return a[i]}return a[0]}

/* ---------- configurador ---------- */
function shoe(){
  var L=find(LEATHERS,S.leather), sole=S.sole==='borracha'?'#2B2723':'#6E5540', suede=S.mat==='camurca'?.24:0, x='';
  if(S.detail==='franja'){for(var i=0;i<7;i++){x+='<rect x="'+(262+i*20)+'" y="118" width="13" height="30" rx="6"/>'}x='<g fill="'+L.c+'">'+x+'</g>'}
  var knot=S.detail==='no'?'<g stroke="#EDE4D4" stroke-width="5" fill="none" opacity=".92" stroke-linecap="round"><path d="M300 128C316 112 344 112 358 128s-.5 30-18 24c-18-6-24-22-8-30s34 2 36 16"/><path d="M292 142c18-8 44-6 60 4"/></g>':'';
  var mono=S.detail==='mono'?'<text x="332" y="148" font-family="Georgia,serif" font-size="30" fill="#F4EBD8" opacity=".55">DS</text>':'';
  return '<svg viewBox="0 0 520 300" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Pré-visualização do par"><defs>'+
   '<linearGradient id="up" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+L.c+'"/><stop offset="1" stop-color="'+L.s+'"/></linearGradient>'+
   '<linearGradient id="sh" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity="'+(0.3-suede)+'"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>'+
   '<filter id="soft"><feGaussianBlur stdDeviation="5"/></filter></defs>'+
   '<ellipse cx="262" cy="262" rx="200" ry="12" fill="#1A1613" opacity=".15" filter="url(#soft)"/>'+
   '<path d="M70 232C60 186 86 150 132 136c44-14 74-18 114-32 46-16 84-30 126-22 48 9 76 44 80 86 4 38-16 64-50 70-72 12-252 12-332-6Z" fill="url(#up)"/>'+
   '<path d="M70 232C60 186 86 150 132 136c44-14 74-18 114-32 46-16 84-30 126-22 48 9 76 44 80 86 4 38-16 64-50 70-72 12-252 12-332-6Z" fill="url(#sh)"/>'+
   '<path d="M238 110c34 18 62 30 106 32 40 2 66-6 84-18-8-18-30-34-56-40-40-8-80 6-134 26Z" fill="'+L.s+'" opacity=".72"/>'+
   x+knot+mono+
   '<path d="M64 234c86 20 276 20 342 6 32-7 46-14 50-26 4 18-12 38-52 44-74 12-262 10-338-8Z" fill="'+sole+'"/>'+
   '<path d="M78 236c82 16 252 16 322 4" stroke="#F2E9D8" stroke-width="2" fill="none" opacity=".45" stroke-dasharray="5 7"/></svg>';
}
function supp(){return find(LEATHERS,S.leather).add+find(MATS,S.mat).add+find(SOLES,S.sole).add+find(DETAILS,S.detail).add}
function paint(){
  var el=document.getElementById('shoe'); if(!el)return;
  el.innerHTML=shoe();
  var t=document.getElementById('cfgtotal'); if(t)t.textContent=money(S.base+supp());
  var set=function(id,v){var e=document.getElementById(id); if(e)e.value=v};
  set('p-leather',find(LEATHERS,S.leather).n); set('p-mat',find(MATS,S.mat).n);
  set('p-sole',find(SOLES,S.sole).n); set('p-detail',find(DETAILS,S.detail).n);
  set('p-size',S.size||''); set('p-supp',money(supp()));
  if(THREE_VIEW)THREE_VIEW.update(S);
}

/* ---------- visor 3D ---------- */
/* Fallback local: garante que o configurador funciona mesmo quando o CDN WebGL está bloqueado. */
function initCanvas3D(host){
  var c=document.createElement('canvas'),ctx=c.getContext('2d'),angle=0,drag=false,last=0;
  host.innerHTML=''; host.appendChild(c); host.style.background='linear-gradient(145deg,#fff,#f1f3f7)';
  function resize(){var r=host.getBoundingClientRect();c.width=Math.max(1,Math.floor(r.width*devicePixelRatio));c.height=Math.max(1,Math.floor(r.height*devicePixelRatio));c.style.width='100%';c.style.height='100%';draw()}
  function draw(){var w=c.width,h=c.height,d=devicePixelRatio||1,s=Math.min(w,h)/340, cx=w/2, cy=h/2+18*d, L=find(LEATHERS,S.leather), sole=S.sole==='borracha'?'#2b2723':'#6e5540', turn=Math.cos(angle), depth=.74+.26*Math.abs(turn), flip=turn<0?-1:1;
    ctx.clearRect(0,0,w,h); ctx.save(); ctx.translate(cx,cy); ctx.scale(s,s);
    ctx.fillStyle='rgba(12,26,60,.14)';ctx.beginPath();ctx.ellipse(0,82,130,13,0,0,Math.PI*2);ctx.fill();
    ctx.scale(depth,1);ctx.scale(flip,1);
    ctx.fillStyle=sole;ctx.beginPath();ctx.roundRect(-142,34,284,34,12);ctx.fill();
    ctx.fillStyle=L.c;ctx.beginPath();ctx.moveTo(-132,31);ctx.bezierCurveTo(-143,-10,-107,-48,-42,-60);ctx.bezierCurveTo(20,-72,91,-75,131,-39);ctx.bezierCurveTo(153,-18,148,27,119,37);ctx.bezierCurveTo(52,54,-66,52,-132,31);ctx.fill();
    ctx.fillStyle=L.s;ctx.globalAlpha=.65;ctx.beginPath();ctx.moveTo(-17,-60);ctx.bezierCurveTo(30,-71,82,-65,116,-39);ctx.bezierCurveTo(90,-28,50,-24,4,-31);ctx.closePath();ctx.fill();ctx.globalAlpha=1;
    if(S.detail==='no'){ctx.strokeStyle='#e9ddc8';ctx.lineWidth=5;ctx.beginPath();ctx.arc(45,-39,18,0,Math.PI*1.6);ctx.arc(58,-39,18,Math.PI,Math.PI*2.6);ctx.stroke()}
    if(S.detail==='franja'){ctx.strokeStyle=L.c;ctx.lineWidth=9;for(var i=-2;i<4;i++){ctx.beginPath();ctx.moveTo(-3+i*12,-44);ctx.lineTo(2+i*12,-12);ctx.stroke()}}
    if(S.detail==='mono'){ctx.fillStyle='#e9ddc8';ctx.font='italic 17px Georgia';ctx.fillText('DS',35,-30)}
    ctx.restore();
  }
  resize();window.addEventListener('resize',resize);
  c.addEventListener('pointerdown',function(e){drag=true;last=e.clientX;c.setPointerCapture&&c.setPointerCapture(e.pointerId)});
  c.addEventListener('pointermove',function(e){if(drag){angle+=(e.clientX-last)*.012;last=e.clientX;draw()}});c.addEventListener('pointerup',function(){drag=false});c.addEventListener('pointercancel',function(){drag=false});
  THREE_VIEW={update:function(){draw()},rotateBy:function(v){angle+=v;draw()}}; draw(); return c;
}
function init3D(hostId){
  var host=document.getElementById(hostId||'shoe-3d'); if(!host)return;
  initCanvas3D(host);
  var load=import('https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js');
  load.then(function(THREE){
    var scene=new THREE.Scene(), camera=new THREE.PerspectiveCamera(24,1,.1,100);
    camera.position.set(4.9,2.8,6.4); camera.lookAt(0,.2,0);
    var renderer=new THREE.WebGLRenderer({alpha:true,antialias:true}); renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2)); renderer.outputColorSpace=THREE.SRGBColorSpace; host.innerHTML=''; host.appendChild(renderer.domElement);
    var group=new THREE.Group(); group.rotation.y=-.28; scene.add(group);
    scene.add(new THREE.HemisphereLight(0xffffff,0x0c1a3c,2.3));
    var key=new THREE.DirectionalLight(0xffffff,3.2); key.position.set(3,6,5); scene.add(key);
    var rim=new THREE.DirectionalLight(0xa98b4a,1.5); rim.position.set(-4,2,-3); scene.add(rim);
    var upperMat=new THREE.MeshStandardMaterial({color:0x8a5a32,roughness:.42,metalness:0});
    var soleMat=new THREE.MeshStandardMaterial({color:0x6e5540,roughness:.58,metalness:0});
    var goldMat=new THREE.MeshStandardMaterial({color:0xa98b4a,roughness:.24,metalness:.78});
    var upper=new THREE.Mesh(new THREE.SphereGeometry(1,48,24),upperMat); upper.scale.set(2.65,.72,1.18); upper.position.set(.12,.55,0); upper.rotation.z=-.05; group.add(upper);
    var vamp=new THREE.Mesh(new THREE.SphereGeometry(1,48,24),upperMat); vamp.scale.set(1.65,.36,1.03); vamp.position.set(1.02,.83,0); group.add(vamp);
    var sole=new THREE.Mesh(new THREE.BoxGeometry(5.55,.28,2.15),soleMat); sole.position.set(.05,-.05,0); sole.scale.set(1,.82,1); group.add(sole);
    var heel=new THREE.Mesh(new THREE.BoxGeometry(.84,.72,1.7),soleMat); heel.position.set(-2.12,.18,0); group.add(heel);
    var knot=new THREE.Group();
    var ring1=new THREE.Mesh(new THREE.TorusGeometry(.34,.09,16,36),goldMat); ring1.rotation.x=Math.PI/2; ring1.rotation.z=.32; ring1.position.set(.88,1.06,0); knot.add(ring1);
    var ring2=ring1.clone(); ring2.rotation.z=-.32; ring2.position.x=1.15; knot.add(ring2); group.add(knot);
    var fringe=new THREE.Group(); for(var i=0;i<6;i++){var tassel=new THREE.Mesh(new THREE.CapsuleGeometry(.055,.42,8,12),upperMat);tassel.position.set(.25+i*.18,1.02,0);tassel.rotation.z=.16;fringe.add(tassel)} group.add(fringe);
    var shadow=new THREE.Mesh(new THREE.CircleGeometry(2.5,48),new THREE.MeshBasicMaterial({color:0x0c1a3c,transparent:true,opacity:.12,depthWrite:false})); shadow.rotation.x=-Math.PI/2; shadow.scale.set(1.25,.33,1); shadow.position.y=-.23; scene.add(shadow);
    function resize(){var r=host.getBoundingClientRect(),w=Math.max(1,r.width),h=Math.max(1,r.height);renderer.setSize(w,h,false);camera.aspect=w/h;camera.updateProjectionMatrix()} resize(); window.addEventListener('resize',resize);
    var dragging=false,last=0;
    renderer.domElement.addEventListener('pointerdown',function(e){dragging=true;last=e.clientX;renderer.domElement.setPointerCapture&&renderer.domElement.setPointerCapture(e.pointerId)});
    renderer.domElement.addEventListener('pointermove',function(e){if(dragging){group.rotation.y+=(e.clientX-last)*.012;last=e.clientX}});
    renderer.domElement.addEventListener('pointerup',function(){dragging=false}); renderer.domElement.addEventListener('pointercancel',function(){dragging=false});
    function render(){requestAnimationFrame(render);renderer.render(scene,camera)} render();
    THREE_VIEW={update:function(state){var L=find(LEATHERS,state.leather); upperMat.color.set(L.c); upperMat.roughness=state.mat==='camurca'?.78:state.mat==='cordovan'?.24:.42; soleMat.color.set(state.sole==='borracha'?'#2b2723':'#6e5540'); knot.visible=state.detail==='no'; fringe.visible=state.detail==='franja';},rotateBy:function(delta){group.rotation.y+=delta}};
    THREE_VIEW.update(S); document.getElementById('shoe')&&(document.getElementById('shoe').style.display='none');
  }).catch(function(){var el=document.getElementById('shoe');if(el)el.style.display='block';});
}
function radios(id,arr,key){
  return arr.map(function(o,i){
    return '<input type="radio" name="'+id+'" id="'+id+i+'"'+(S[key]===o.k?' checked':'')+'>'+
      '<label for="'+id+i+'" data-k="'+o.k+'">'+o.n+(o.add?' +'+o.add+'€':'')+'</label>';
  }).join('');
}
function initCfg(){
  if(!document.getElementById('shoe'))return;
  init3D('shoe-3d');
  track('customizer_start',{});
  var lw=document.getElementById('cfg-leather');
  lw.innerHTML=LEATHERS.map(function(l){
    return '<button type="button" class="mat'+(S.leather===l.k?' on':'')+'" data-k="'+l.k+'"><i style="background:linear-gradient(150deg,'+l.c+','+l.s+')"></i><span>'+l.n+(l.add?' +'+l.add+'€':'')+'</span></button>';
  }).join('');
  lw.addEventListener('click',function(e){
    var b=e.target.closest ? e.target.closest('button') : null; if(!b)return;
    S.leather=b.getAttribute('data-k');
    Array.prototype.forEach.call(lw.children,function(c){c.className='mat'+(c===b?' on':'')});
    paint();
  });
  [['cfg-mat',MATS,'mat'],['cfg-sole',SOLES,'sole'],['cfg-detail',DETAILS,'detail']].forEach(function(t){
    var w=document.getElementById(t[0]); if(!w)return;
    w.innerHTML=radios(t[0],t[1],t[2]);
    w.addEventListener('change',function(e){
      var lb=w.querySelector('label[for="'+e.target.id+'"]'); if(lb){S[t[2]]=lb.getAttribute('data-k');paint()}
    });
  });
  var sw=document.getElementById('cfg-size');
  if(sw){
    sw.innerHTML=SIZES.map(function(s,i){return '<input type="radio" name="cfgsize" id="cs'+i+'"><label for="cs'+i+'" data-k="'+s+'">'+s+'</label>'}).join('');
    sw.addEventListener('change',function(e){
      var lb=sw.querySelector('label[for="'+e.target.id+'"]'); if(lb){S.size=lb.getAttribute('data-k');paint()}
    });
  }
  var mw=document.getElementById('cfg-model');
  if(mw){
    var apply=function(inp){
      S.base=parseFloat(inp.getAttribute('data-price')||0);
      var v=document.getElementById('cfgvariant'); if(v)v.value=inp.value;
      paint();
    };
    mw.addEventListener('change',function(e){if(e.target.tagName==='INPUT')apply(e.target)});
    var requested='';
    try{requested=(new URLSearchParams(window.location.search)).get('modelo')||''}catch(e){}
    var selected=null,choices=mw.querySelectorAll('input[data-handle]');
    for(var q=0;q<choices.length;q++)if(choices[q].getAttribute('data-handle')===requested){selected=choices[q];break}
    var first=selected||mw.querySelector('input:checked')||mw.querySelector('input');
    if(first){first.checked=true;apply(first)}
  }
  var f=document.getElementById('cfgform');
  if(f)f.addEventListener('submit',function(e){if(!S.size){e.preventDefault();alert(tr('configurator.choose_size',T.c.choose)||'Choose a size.')}});
  var stage=document.getElementById('shoe-stage');
  if(stage){
    var angle=0,down=false,start=0,from=0;
    var turn=function(v){var prev=angle;angle=Math.max(-28,Math.min(28,v));if(THREE_VIEW&&THREE_VIEW.rotateBy){THREE_VIEW.rotateBy(angle-prev);return}var visual=document.getElementById('shoe');if(visual)visual.style.transform='rotateY('+angle+'deg) rotateX('+(Math.abs(angle)*-.08)+'deg)'};
    stage.addEventListener('pointerdown',function(e){if(e.target.closest&&e.target.closest('button'))return;down=true;start=e.clientX;from=angle;stage.setPointerCapture&&stage.setPointerCapture(e.pointerId)});
    stage.addEventListener('pointermove',function(e){if(down)turn(from+(e.clientX-start)*.18)});
    stage.addEventListener('pointerup',function(){down=false});
    stage.addEventListener('pointercancel',function(){down=false});
    stage.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){turn(angle-8);e.preventDefault()}if(e.key==='ArrowRight'){turn(angle+8);e.preventDefault()}});
    Array.prototype.forEach.call(stage.querySelectorAll('[data-shoe-view]'),function(b){b.addEventListener('click',function(){turn(angle+(b.getAttribute('data-shoe-view')==='left'?-14:14))})});
    turn(0);
  }
  paint();
}

/* ---------- variantes na ficha de produto ---------- */
function initGallery(){
  var g=document.getElementById('gal'); if(!g)return;
  var slides=g.querySelectorAll('.slide'), dots=document.getElementById('galdots'),
      prev=document.getElementById('galprev'), next=document.getElementById('galnext');
  if(slides.length<2){ if(prev)prev.style.display='none'; if(next)next.style.display='none'; if(dots)dots.style.display='none'; return; }
  var html='';
  for(var i=0;i<slides.length;i++)html+='<button type="button" aria-label="Imagem '+(i+1)+'"></button>';
  if(dots)dots.innerHTML=html;
  var idx=0;
  function go(n){ idx=Math.max(0,Math.min(slides.length-1,n)); g.scrollTo({left:g.clientWidth*idx,behavior:'smooth'}); mark(); }
  function mark(){
    if(dots)for(var i=0;i<dots.children.length;i++)dots.children[i].className=(i===idx?'on':'');
    if(prev)prev.disabled=(idx===0);
    if(next)next.disabled=(idx===slides.length-1);
  }
  if(prev)prev.addEventListener('click',function(){go(idx-1)});
  if(next)next.addEventListener('click',function(){go(idx+1)});
  if(dots)dots.addEventListener('click',function(e){
    var k=Array.prototype.indexOf.call(dots.children,e.target); if(k>=0)go(k);
  });
  var t; g.addEventListener('scroll',function(){
    clearTimeout(t); t=setTimeout(function(){ idx=Math.round(g.scrollLeft/g.clientWidth); mark(); },90);
  },{passive:true});
  mark();
}
function initPerso(){
  var sw=document.getElementById('perso-on'), body=document.getElementById('perso-body');
  if(!sw||!body)return;
  var sync=function(){
    var on=sw.checked; body.hidden=!on;
    var map=[['pcor','p-cor'],['psola','p-sola'],['pdet','p-detalhe']];
    for(var i=0;i<map.length;i++){
      var c=document.querySelector('input[name="'+map[i][0]+'"]:checked');
      var t=document.getElementById(map[i][1]); if(t)t.value=on&&c?c.value:'';
    }
    var ini=document.getElementById('p-iniciais-in'), it=document.getElementById('p-iniciais');
    if(it)it.value=on&&ini?ini.value.toUpperCase():'';
    if(THREE_VIEW&&on){
      var cv=(document.querySelector('input[name="pcor"]:checked')||{}).value||'';
      var cm={'Cognac':'cognac','Ébano':'ebano','Areia':'areia','Azul-marinho':'oceano','Como na fotografia':'oceano'};
      var sv=(document.querySelector('input[name="psola"]:checked')||{}).value||'';
      var dv=(document.querySelector('input[name="pdet"]:checked')||{}).value||'';
      S.leather=cm[cv]||S.leather; S.sole=sv.indexOf('Borracha')===0?'borracha':'couro'; S.detail=dv.indexOf('Franja')===0?'franja':dv.indexOf('Monograma')===0?'mono':dv.indexOf('Liso')===0?'liso':'no'; THREE_VIEW.update(S);
    }
  };
  sw.addEventListener('change',sync);
  body.addEventListener('change',sync);
  body.addEventListener('input',sync);
  sync();
}
function initProduct(){
  var form=document.querySelector('[data-pform]'); if(!form)return;
  var tag=form.querySelector('[data-variants]'); if(!tag)return;
  var variants=[]; try{variants=JSON.parse(tag.textContent)}catch(e){return}
  var vid=form.querySelector('[data-vid]'), btn=form.querySelector('[data-add]'),
      msg=form.querySelector('[data-msg]'), priceEl=document.querySelector('[data-price]');
  function chosen(){
    return Array.prototype.map.call(form.querySelectorAll('.opts[data-opt]'),function(g){
      var c=g.querySelector('input:checked'); return c?c.value:null;
    });
  }
  function match(){
    var want=chosen();
    for(var i=0;i<variants.length;i++){
      var v=variants[i], ok=true;
      for(var j=0;j<want.length;j++){ if(want[j]!==null && v.options[j]!==want[j]){ok=false;break} }
      if(ok)return v;
    }
    return null;
  }
  function sync(){
    var v=match();
    if(msg){msg.style.display='none';msg.textContent=''}
    if(!v){ if(btn){btn.disabled=true;btn.querySelector('span').textContent=tr('product.unavailable',T.p.unav)||'Unavailable'} return }
    vid.value=v.id;
    if(priceEl)priceEl.textContent=cents(v.price);
    if(btn){
      btn.disabled=!v.available;
      btn.querySelector('span').textContent=v.available?(tr('product.add',T.p.add)||'Add'):(tr('product.sold_out',T.p.sold)||'Sold out');
    }
    if(!v.available && msg){msg.style.display='block';msg.textContent=tr('product.variant_sold_out',T.p.vsold)||''}
  }
  form.addEventListener('change',sync);
  sync();
}

/* ---------- carrinho ---------- */
function renderCart(cart){
  var cn=document.getElementById('cn'); if(cn)cn.textContent=cart.item_count;
  var b=document.getElementById('dbody'), f=document.getElementById('dfoot'); if(!b||!f)return;
  if(!cart.items.length){
    b.innerHTML='<p class="muted" style="text-align:center;padding:80px 0;font-size:13.5px">'+tr('cart.empty',T.cart.empty)+'</p>';
    f.innerHTML='<a class="btn dark block" href="/collections/all"><span>'+tr('cart.see_collection',T.cart.see)+'</span></a>';
    return;
  }
  b.innerHTML=cart.items.map(function(i,idx){
    var props='';
    if(i.properties){for(var k in i.properties){if(i.properties[k])props+='<small>'+k+': '+i.properties[k]+'</small>'}}
    var img=i.image;
    if(!img){
      var h=((i.handle||'')+' '+(i.url||'')+' '+(i.product_title||'')).toLowerCase(), F=window.MDS_FALLBACK||{};
      if(h.indexOf('navegante')>-1)img=F.navegante;
      else if(h.indexOf('reis')>-1)img=F.reis;
      else img=F.generico;
    }
    return '<div class="ln"><div class="im">'+(img?'<img src="'+img+'" alt="">':'')+'</div>'+
      '<div><strong>'+i.product_title+'</strong>'+(i.variant_title&&i.variant_title!=='Default Title'?'<small>'+i.variant_title+'</small>':'')+
      (i.quantity>1?'<small>'+(T._lang==='en'?'Quantity':'Quantidade')+': '+i.quantity+'</small>':'')+props+
      '<small style="color:var(--gold-text)">'+(T._lang==='en'?'Production 4 to 6 weeks':'Produção 4 a 6 semanas')+'</small>'+
      '<button type="button" data-rm="'+(idx+1)+'">'+tr('cart.remove',T.cart.remove)+'</button></div>'+
      '<div>'+cents(i.final_line_price)+'</div></div>';
  }).join('');
  f.innerHTML='<div class="row"><span>'+tr('cart.subtotal',T.cart.subtotal)+'</span><span>'+cents(cart.total_price)+'</span></div>'+
   '<div class="row"><span>'+(T._lang==='en'?'Production':'Produção')+'</span><span>'+(T._lang==='en'?'4–6 weeks':'4 a 6 semanas')+'</span></div>'+'<div class="row"><span>'+tr('cart.shipping',T.cart.shipping)+'</span><span>'+tr('cart.complimentary',T.cart.free)+'</span></div>'+
   '<div class="row t"><span>'+tr('cart.total',T.cart.total)+'</span><span>'+cents(cart.total_price)+'</span></div>'+
   '<a class="btn fill block" href="/checkout"><span>'+tr('cart.checkout',T.cart.checkout)+'</span></a>'+
   '<p class="muted" style="font-size:11.5px;margin-top:16px;text-align:center">'+tr('cart.methods',T.cart.methods)+'</p>';

}
function initCartRemove(){
  var b=document.getElementById('dbody'); if(!b||b.dataset.rmBound)return;
  b.dataset.rmBound='1';
  b.addEventListener('click',function(e){
    var el=e.target.closest ? e.target.closest('[data-rm]') : null;
    if(!el)return;
    e.preventDefault();
    el.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:parseInt(el.getAttribute('data-rm'),10),quantity:0})})
      .then(function(r){return r.json()}).then(renderCart)
      .catch(function(){el.disabled=false});
  });
}
function fetchCart(open){
  return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()})
    .then(function(c){renderCart(c); if(open)MDS.openCart(); return c});
}

var MDS={
  mnav:function(o){var m=document.getElementById('mnav'); if(m)m.classList.toggle('on',!!o); document.body.style.overflow=o?'hidden':''},
  openCart:function(){document.getElementById('dr').classList.add('on');document.getElementById('scrim').classList.add('on')},
  closeCart:function(){document.getElementById('dr').classList.remove('on');document.getElementById('scrim').classList.remove('on')},
  closeAll:function(){MDS.closeCart();document.getElementById('md').classList.remove('on');document.getElementById('scrim').classList.remove('on');MDS.mnav(0)},
  modal:function(h){document.getElementById('mb').innerHTML=h;document.getElementById('md').classList.add('on');document.getElementById('scrim').classList.add('on')},
  search:function(open){
    var h=document.getElementById('hdr'); if(!h)return;
    var show = (open===0) ? false : !h.classList.contains('searching');
    h.classList.toggle('searching',show);
    if(show){ var i=h.querySelector('.searchbar input'); if(i)setTimeout(function(){i.focus()},120); }
  },
  guia:function(){
    var rows=[['35','22,3'],['36','23,0'],['37','23,7'],['38','24,4'],['39','25,1'],['40','25,8'],
              ['41','26,5'],['42','27,2'],['43','27,9'],['44','28,6'],['45','29,3']];
    var en=(T._lang==='en');
    var t='<table style="width:100%;border-collapse:collapse;font-size:13.5px;margin:18px 0">'+
      '<tr><th style="text-align:left;padding:0 0 8px;border-bottom:1px solid var(--line);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--taupe);font-weight:400">'+(en?'Size':'Tamanho')+'</th>'+
      '<th style="text-align:right;padding:0 0 8px;border-bottom:1px solid var(--line);font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--taupe);font-weight:400">'+(en?'Foot length':'Comprimento do pé')+'</th></tr>';
    for(var i=0;i<rows.length;i++){
      t+='<tr><td style="padding:9px 0;border-bottom:1px solid rgba(12,26,60,.07)">'+rows[i][0]+'</td>'+
         '<td style="padding:9px 0;border-bottom:1px solid rgba(12,26,60,.07);text-align:right">'+rows[i][1]+' cm</td></tr>';
    }
    t+='</table>';
    MDS.modal('<h3>'+(en?'Size guide':'Guia de tamanhos')+'</h3>'+
      '<p class="sub-t">'+(en?'Measure at the end of the day, wearing the sock you will use.':'Meça ao fim do dia, com a meia que vai usar.')+'</p>'+
      '<ol style="font-size:13.5px;color:var(--muted);padding-left:18px;line-height:1.9;margin:0 0 6px">'+
      '<li>'+(en?'Place your foot on an A4 sheet against the wall, heel to the wall.':'Pouse o pé numa folha A4 encostada à parede, com o calcanhar na parede.')+'</li>'+
      '<li>'+(en?'Mark the longest toe.':'Marque o dedo mais comprido.')+'</li>'+
      '<li>'+(en?'Measure from wall to mark, in centimetres.':'Meça da parede à marca, em centímetros.')+'</li>'+
      '<li>'+(en?'Repeat on the other foot and use the larger.':'Repita no outro pé e use o maior.')+'</li></ol>'+
      t+
      '<p class="muted" style="font-size:12.5px">'+(en?'Between two sizes, choose the larger. In doubt, write to us — the atelier answers within two working days. Bespoke pieces have no chart: we make to your foot.':'Entre dois tamanhos, escolha o maior. Em caso de dúvida, escreva-nos — o atelier responde em dois dias úteis. Em peças sob medida não há tabela: fazemos ao seu pé.')+'</p>'+
      '<button class="btn dark block" style="margin-top:18px" onclick="MDS.closeAll()">'+(en?'Close':'Fechar')+'</button>');
  },
  appt:function(what){
    track('private_visit_request',{subject:what||'Visita privada'});
    var subj=what?String(what).replace(/"/g,'').replace(/</g,''):'Visita privada';
    MDS.modal('<h3>'+tr('appointment.title',T.a.title)+'</h3><p class="muted" style="margin-bottom:28px">'+tr('appointment.sub',T.a.sub)+'</p>'+
     '<form method="post" action="/contact#contact_form" accept-charset="UTF-8"><input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">'+
     '<input type="hidden" name="contact[Assunto]" value="'+subj+'">'+
     (what?'<p class="muted" style="font-size:13px;margin-bottom:20px">'+tr('appointment.subject',T.a.subject)+': <b style="color:var(--ink);font-weight:400">'+subj+'</b></p>':'')+
     '<div class="two"><input name="contact[name]" placeholder="'+tr('general.name',T.g.name)+'" required><input name="contact[phone]" placeholder="'+tr('general.phone',T.g.phone)+'"></div>'+
     '<div style="margin-top:20px"><input type="email" name="contact[email]" placeholder="'+tr('general.email',T.g.email)+'" required></div>'+
     '<div class="two" style="margin-top:20px"><input type="date" name="contact[Dia]"><select name="contact[Hora]"><option>10:00</option><option>11:30</option><option>15:00</option><option>16:30</option></select></div>'+
     '<div style="margin-top:20px"><textarea name="contact[body]" placeholder="'+tr('appointment.what',T.a.what)+'"></textarea></div>'+
     '<p class="muted" style="font-size:11.5px;margin:20px 0 24px">'+tr('appointment.note',T.a.note)+'</p>'+
     '<button type="submit" class="btn fill block"><span>'+tr('appointment.cta',T.a.cta)+'</span></button></form>');
  }
};
window.MDS=MDS;

function initVideo(){
  var v=document.getElementById('herovid'), b=document.getElementById('vidplay');
  if(!v){ if(b)b.style.display='none'; return; }
  v.muted=true; v.defaultMuted=true; v.setAttribute('muted','');
  var tryPlay=function(){ var pr=v.play(); if(pr&&pr.catch)pr.catch(function(){}); };
  tryPlay();
  v.addEventListener('loadeddata',tryPlay);
  v.addEventListener('canplay',tryPlay);
  document.addEventListener('touchstart',function once(){tryPlay();document.removeEventListener('touchstart',once)},{passive:true});
  document.addEventListener('visibilitychange',function(){ if(!document.hidden)tryPlay(); });
  if(!b)return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){try{v.pause()}catch(e){}b.textContent='▶';}
  b.addEventListener('click',function(){
    if(v.paused){v.play();b.textContent='❙❙';b.setAttribute('aria-label','Pausa')}
    else{v.pause();b.textContent='▶';b.setAttribute('aria-label','Reproduzir')}
  });
  v.addEventListener('error',function(){v.style.display='none'});
}
/* ---------- idioma PT / EN ---------- */
var LANG=(function(){try{return localStorage.getItem('mds_lang')||'pt'}catch(e){return 'pt'}})();
function applyLang(l){
  LANG=l;
  try{localStorage.setItem('mds_lang',l)}catch(e){}
  document.documentElement.setAttribute('lang', l==='en'?'en':'pt-PT');
  var bs=document.querySelectorAll('.langsel [data-lang]');
  for(var q=0;q<bs.length;q++){
    bs[q].className=(bs[q].getAttribute('data-lang')==='pt'?'l-pt':'l-en')+(bs[q].getAttribute('data-lang')===l?' on':'');
  }
  var n=document.querySelectorAll('[data-en]');
  for(var i=0;i<n.length;i++){
    var e=n[i];
    if(e.getAttribute('data-pt')===null)e.setAttribute('data-pt',e.innerHTML);
    e.innerHTML = l==='en' ? e.getAttribute('data-en') : e.getAttribute('data-pt');
  }
  var ph=document.querySelectorAll('[data-en-ph]');
  for(var j=0;j<ph.length;j++){
    var x=ph[j];
    if(x.getAttribute('data-pt-ph')===null)x.setAttribute('data-pt-ph',x.placeholder||'');
    x.placeholder = l==='en' ? x.getAttribute('data-en-ph') : x.getAttribute('data-pt-ph');
  }
  T._lang=l;
}
function initLang(){
  applyLang(LANG);
  var bs=document.querySelectorAll('.langsel [data-lang]');
  for(var i=0;i<bs.length;i++){
    bs[i].addEventListener('click',function(){ applyLang(this.getAttribute('data-lang')); });
  }
}
/* ---- Cuidados e reparação: separar as quatro expressões em subtítulos ---- */
function initSubheads(){
  var wrap=document.querySelector('.template-page .rte'); if(!wrap)return;
  var leads=['O número de série','Pedir uma reparação','Cuidados diários','Trocas e devoluções',
             'Your serial number','Request a repair','Everyday care','Exchanges and returns'];
  var ps=wrap.querySelectorAll('p');
  for(var i=0;i<ps.length;i++){
    var p=ps[i], txt=(p.textContent||'').replace(/^\s+/,'');
    for(var k=0;k<leads.length;k++){
      var L=leads[k];
      if(txt.indexOf(L+'.')===0||txt.indexOf(L+':')===0){
        var resto=txt.slice(L.length+1).replace(/^\s+/,'');
        var h=document.createElement('span');
        h.className='sub-head';
        h.textContent=L;
        p.parentNode.insertBefore(h,p);
        p.textContent=resto;
        break;
      }
    }
  }
}
function initForms(){
  document.addEventListener('submit',function(e){
    var f=e.target;
    if((f.getAttribute('action')||'').indexOf('/cart/add')>-1)return;
    var b=f.querySelector('[type=submit]');
    if(b && !b.disabled){
      var txt=b.textContent;
      b.disabled=true;
      b.setAttribute('data-busy','1');
      setTimeout(function(){ b.disabled=false; b.removeAttribute('data-busy'); }, 6000);
      track('form_submit',{form:(f.querySelector('[name="form_type"]')||{}).value||'generic'});
    }
  },true);
}
/* eventos de analytics — só dispara se houver dataLayer ou gtag */
function track(name,params){
  try{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({event:name}, params||{}));
    if(typeof window.gtag==='function')window.gtag('event',name,params||{});
  }catch(e){}
}
function boot(){
  initSubheads();
  initLang();
  initVideo();
  initPerso();
  initGallery();
  initCartRemove();
  initForms();
  initCfg(); if(document.getElementById('product-shoe-3d'))init3D('product-shoe-3d'); initProduct(); fetchCart(false);
  var hero=document.querySelector('main > .hero, main > section > .hero');
  document.body.classList.toggle('has-hero',!!hero);
  var hdr=document.getElementById('hdr');
  var setH=function(){ if(hdr)document.documentElement.style.setProperty('--hdr-h',hdr.offsetHeight+'px'); };
  setH(); window.addEventListener('resize',setH);
  function atTop(){document.body.classList.toggle('at-top',!!hero && window.scrollY<80)}
  atTop(); window.addEventListener('scroll',atTop,{passive:true});
  window.addEventListener('resize',atTop);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){MDS.search(0);MDS.closeAll()}});

  document.addEventListener('submit',function(e){
    var f=e.target;
    var act=(f.getAttribute('action')||'');
    if(act.indexOf('/cart/add')===-1)return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]'); var old=btn?btn.querySelector('span').textContent:'';
    if(btn){btn.disabled=true;btn.querySelector('span').textContent=tr('product.adding',T.p.adding)||'…'}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})})
      .then(function(res){
        if(btn){btn.disabled=false;btn.querySelector('span').textContent=old}
        if(!res.ok){
          var m=f.querySelector('[data-msg]');
          var txt=res.d.description||res.d.message||(tr('product.unavailable',T.p.unav)||'Unavailable');
          if(m){m.style.display='block';m.textContent=txt}else{alert(txt)}
          return;
        }
        track('add_to_cart',{items:[{item_name:(document.querySelector('.buy h1')||{}).textContent||''}]});
        fetchCart(true);
      })
      .catch(function(){ if(btn){btn.disabled=false;btn.querySelector('span').textContent=old} f.submit(); });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot); else boot();
})();
